import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, MoonStar } from "lucide-react";

const EVENTS = [
  { name: "Maya R.", loc: "Austin", action: "started Night 1" },
  { name: "Derek T.", loc: "London", action: "got the Sleep Reset" },
  { name: "Sofia L.", loc: "Toronto", action: "downloaded the guide" },
  { name: "Jamal K.", loc: "Berlin", action: "added the 3AM Playbook" },
  { name: "Priya N.", loc: "Sydney", action: "started Night 1" },
  { name: "Leo M.", loc: "Los Angeles", action: "got the Sleep Reset" },
  { name: "Hannah W.", loc: "Chicago", action: "downloaded the guide" },
  { name: "Owen P.", loc: "Dublin", action: "added the 3AM Playbook" },
];

const FIRST_DELAY_MS = 9000;
const SHOW_MS = 6000;
const GAP_MS = 22000;
const MAX_SHOWS = 6;

export function SocialProofToast() {
  const [current, setCurrent] = useState(null);
  const [shows, setShows] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed || shows >= MAX_SHOWS) return;
    const timer = setTimeout(() => {
      setCurrent({ ...EVENTS[(Date.now() / 1000 | 0) % EVENTS.length], mins: 1 + ((Date.now() / 60 | 0) % 14) });
      setShows((s) => s + 1);
    }, shows === 0 ? FIRST_DELAY_MS : GAP_MS);
    return () => clearTimeout(timer);
  }, [shows, dismissed]);

  useEffect(() => {
    if (!current) return;
    const t = setTimeout(() => setCurrent(null), SHOW_MS);
    return () => clearTimeout(t);
  }, [current]);

  return (
    <AnimatePresence>
      {current && !dismissed && (
        <motion.div
          data-testid="social-proof-toast"
          initial={{ opacity: 0, y: 24, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.95 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="glass fixed bottom-24 left-4 z-40 flex max-w-[280px] items-center gap-3 rounded-2xl border border-white/15 p-3.5 shadow-[0_16px_50px_rgba(0,0,0,0.55)] sm:bottom-6 sm:left-6"
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cyan-400/15">
            <MoonStar className="h-4 w-4 text-cyan-300" />
          </span>
          <span className="min-w-0 text-xs leading-snug text-slate-300">
            <strong className="text-white">{current.name}</strong> from {current.loc} {current.action}
            <span className="mt-0.5 block text-[10px] text-slate-500">{current.mins} min ago · verified</span>
          </span>
          <button
            data-testid="social-proof-toast-close"
            onClick={() => { setCurrent(null); setDismissed(true); }}
            className="ml-auto shrink-0 rounded-full p-1 text-slate-500 transition-colors hover:text-white"
            aria-label="Dismiss"
          >
            <X className="h-3 w-3" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
